import { render, staticRenderFns } from "./PaymentPolicy.vue?vue&type=template&id=66bb3664&"
import script from "./PaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./PaymentPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports